import { Component, OnInit, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Category } from '../../../../documents';
import { isEmpty } from 'lodash';

@Component({
    selector: 'category-select',
    template: require('./category-select.component.html'),
    styles: [require('./shared/select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategorySelectComponent implements OnInit {
    @Input()
    public control: FormControl;

    @Input()
    public categories: Category[];

    @Input()
    public valueChangeConfirmationText: string;

    @Input()
    @HostBinding('class.disabled')
    public disabled = false;

    public selectedCategories: Category[];

    public requiredErrorName = 'required';

    public ngOnInit() {
        this.control.setValidators(this.validateNotEmpty());
        this.control.updateValueAndValidity();
    }

    public onCategoryChange(categories: Category[]) {
        if (isEmpty(categories)) {
            this.selectedCategories = [];
            this.control.setValue(null);
        } else {
            this.selectedCategories = categories;
            this.control.setValue(categories[0].categoryId);
        }
    }

    private validateNotEmpty(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            return isEmpty(control.value)
                ? { [this.requiredErrorName]: true }
                : null;
        };
    }
}